import {area, mk} from '@mintdata/mint-kit/api/log/mk';
import {Icons, SvgIcons} from '@mintdata/mint-kit/impl/properties/components/svgIcon/SvgIcons';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./SvgIcon.less');
const cx = classnames.bind(styles);

export interface ISvgIconProps
{
    name:SvgIcons;
    className?:string;
    onClick?:React.MouseEventHandler<any>;
    onMouseDown?:React.MouseEventHandler<any>;
}

export class SvgIcon extends React.Component<ISvgIconProps, any>
{
    public render():JSX.Element
    {
        const {
            name,
            className,
            onClick = null,
            onMouseDown = null
        } = this.props;

        try
        {
            const Svg = Icons.get(name);

            if( !Svg ) return null;

            return (
                <Svg onClick={onClick}
                     onMouseDown={onMouseDown}
                     className={cx('base', className)}
                />
            );
        }
        catch( error )
        {
            mk.error(area.Icon, 'Could not find icon with name:', name);
            return null;
        }
    }
}
